import AddressManagerController from './address-manager-controller'

export default AddressManagerController
